export class langdrivers {
    public key: string = "";
    public value: string = "";
}
export enum zone { ownconfig = 0, sharedconfig = 1, afficheranonyme = 2, sharedconfiguser = 3 };
export enum categories { PCIDisplay, PCIStockage, Motherboard, PCINetwork, PCIMultimedia, Mouse, Keyboard, PCIUSB, PCIFirewire, USBMultimedia, USB, USBClass, Firewire, Processor, PNP, HardDrive, Optical, Ecran, Imprimante, PCIothers, Others };

export class ConfMenuElem {
    public id: number = 0;
    public text: string = "";
    public selected: boolean = false;
    public url: string = "";
}

export class MesDriversMenuOS2 {
    public name: string = "";
    public value: number = 0;
    public archi: number = 0;
}

export class HidElem {
    public  id: number = 0;
    public  infid: number = 0;
    public  idpackage: number = 0;
    public  constid: number = 0;
    public  hid:string="";
    public  matosid: number = 0;
    public date: Date | null=null;
    public  version: string = "";
    public  nameinf: string = "";
    public  vendor: string = "";
    public  classe: string = "";
    public  whql: boolean = false;
    public  beta: boolean = false;
    public  oem: boolean = false;
    public  datepubli!:Date;
    public datepubli1:Date|null=null;
    public  url: string = "";
    public  md5: string = "";
    public  namedriver: string = "";
    public  cat: number = 0;
    public  subsysid: number = 0;
    public  mcvendorid: number = 0;
    public  driveronftp: boolean = false;
    public  os:number[]=[];
    public  nameos: string = "";
    public  langue: string = "";
    public  sizefile: number = 0;
    public  versionproduct: string = "";
    public  mcvendor: string = "";
    public  inf_stateupdate: number = 0;
    public  infpath: string = "";
    public  package: number = 0;
    public hasinfzip: boolean = false;
    public  listeos: string = "";
    public  sizeinoctets: string = "";
    public  urlinformationdriver: string = "";
}

export class MesDriversMenuOptions2 {
    public label: string = "";
    public show: boolean = false;
    public ischecked: boolean = false;
}

export class MesDriversDriver2 {
    public driver_ignoredriver: boolean = false;
    public driver_urldrivers: string = "";
    public driver_constructeur: string = "";
    public driver_nom: string = "";
    public driver_version: string = "";
    public driver_date: Date | null = null;
    public driver_datepubli: Date | null = null;
    public driver_md5: string = "";
    public driver_oem: boolean = false;
    public driver_cat: number = 0;
    public driver_sizefile: string = "";
    public driver_versionproduct: string = "";
    public driver_whql: boolean = false;
    public driver_beta: boolean = false;
    public inf_fichier: string = "";
    public inf_provider: string = "";
    public inf_version: string = "";
    public inf_date: Date | null = null;
    public inf_classe: string = "";
    public inf_classe_guid: string = "";
    public driver_requete: number = 0;
    public inf_hassubsys: number = 0;
    public driver_url: string = "";
    public driver_url2: string = "";
    public driver_ficheurl: string = "";
    public stateupdate: number = 0;
    public driver_code: number = 0;
    public inf_code: number = 0;
    public driver_note: number = 0;
    public inf_path: string = "";
    public inf_urlauto: string = "";
    public driver_hasinfzip: boolean = false;
    public inf_idpackage: number = 0;
}

export class MesDriversMatos2 {
    public materiel_id: number = 0;
    public materiel_categorie: categories = categories.Others;
    public materiel_icone: string = "";
    public materiel_devicename: string = "";
    public materiel_providername: string = "";
    public materiel_installed: boolean = false;
    public materiel_probleme: boolean = false;
    public materiel_classe: string = "";
    public materiel_classe_guid: string = "";
    public materiel_version: string = "";
    public materiel_fichier: string = "";
    public materiel_hid: string = "";
    public materiel_urllaptop2go: string = "";
    public materiel_date: Date | null = null;
    public materiel_driversanterieur: boolean = true;
    public drivers: MesDriversDriver2[] = [];
}



export class MaterielXMLRelation {
    public key: categories = categories.Others;
    public value: MesDriversMatos2[] = [];
    public active: boolean = true;
}

export class ConfMenuToolbar {
    public text: string = "";
    public icon: string = "";
    public url: string = "";
    public clickevent: string = "";
}

export class ServiceDriversApiViewModel {
    public m_iduser: number = 0;
    public m_islogin: boolean = false;
    public m_machine: number = 0;
    public DeviceId: number = 0;
    public m_dateconfigexpiration: Date | null = null;
    public m_zone: zone = zone.afficheranonyme;
    public m_idconfig: number = 0;
    public confmachines: ConfMenuElem[] = [];
    public confmachinesshare: ConfMenuElem[] = [];
    public conftoolbar: ConfMenuToolbar[] = [];
    public conftoolbar2: ConfMenuToolbar[] = [];
    public m_listecategories: categories[] = [];
    public osactual: number = 0;
    public menuos: MesDriversMenuOS2[] = [];
    public mcdroptions: MesDriversMenuOptions2[] = [];
    public mcdroptions2: MesDriversMenuOptions2[] = [];
    public mesdriverserror: string = "";
    public installauto: boolean = false;
    public materielxmlrelations: MaterielXMLRelation[] = [];
    public notifemail: boolean = false;
    public m_erreur: string = "";
    public m_msgnewversion: string = "";
}

export class DriversAutoRequest {
    public idconfig: number = 0;
    public checkeddrivers: number[] = [];
    }